'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragHandle = require('./DragHandle');

var _DragHandle2 = _interopRequireDefault(_DragHandle);

require('./ControlPointDragHandle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlPointDragHandle = function ControlPointDragHandle(props) {
    return _react2.default.createElement(_DragHandle2.default, _extends({ className: 'ControlPointDragHandle', style: { background: props.color } }, props));
};

ControlPointDragHandle.propTypes = {
    pos: _propTypes2.default.object,
    color: _propTypes2.default.string,
    show: _propTypes2.default.bool
};

exports.default = ControlPointDragHandle;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/ControlPointDragHandle.js
// module id = 733
// module chunks = 0